module.exports = __webpack_public_path__ + "img/pickUpChiringuito.433763b9.svg";